export default function setPlatformDependentDownloadLink() {
  let el = document.querySelector(".js-nav-download-btn");
  const deviceType = getDeviceType();
  if (deviceType == "Android") {
    el.href = el.dataset.androidUrl;
    el.setAttribute("target", "_blank");
  } else if (deviceType == "iOS") {
    el.href = el.dataset.iosUrl;
    el.setAttribute("target", "_blank");
  } else {
    el.href = el.dataset.otherUrl;
  }
}

function getDeviceType() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}
